import { getCopticFastsFeasts } from "./copticCalendar";
import { regularMonths } from "./date";
import converter from "number-to-words";
import moment from "moment";

const getEvents = (year, monthIndex, day) =>
  getCopticFastsFeasts({ year, monthIndex, day });

export const upcomingEvents = (year, monthIndex, day) => {
  const upcomings = getEvents(year, monthIndex, day);
  return Object.keys(upcomings)
    .filter((x) => !!upcomings[x].start)
    .filter(
      (x) =>
        moment(upcomings[x].start).diff(
          moment(`${year}-${day}-${monthIndex + 1}`, "YYYY-DD-MM"),
          "days"
        ) >= 0 &&
        moment(upcomings[x].start).diff(
          moment(`${year}-${day}-${monthIndex + 1}`, "YYYY-DD-MM"),
          "days"
        ) <= 7
    )
    .map((x) => ({
      event: x,
      date: new Date(upcomings[x].start),
      formattedDate: `${regularMonths[new Date(upcomings[x].start).getMonth()]
        }, ${converter.toOrdinal(new Date(upcomings[x].start).getDate())}`,
    }))
    .sort((a, b) => new Date(a.date) - new Date(b.date));
};
